import { useCallback } from 'react';
import * as authenticationService from '../../data-layer/authentication/service';
import { shareBusinessAsync, subscribeToBusinessAsync } from '../../data-layer/business/actions';
import { useDispatch } from '../../data-layer/useDispatch';
import { fromBusinessUI } from '../../mappers/business/toBusinessModel';
import { EventSource } from '../../utils/analyticsService';
import type { BusinessUI } from '../../ui/business/types';

interface UseBusinessCallbacksPayload {
    onShare: (businessUI: BusinessUI) => void;
    onSubscribe: (businessUI: BusinessUI) => void;
}

export const useBusinessCallbacks = (): UseBusinessCallbacksPayload => {
    const dispatch = useDispatch();

    const onShare = useCallback(
        (businessUI: BusinessUI) => {
            const businessModel = fromBusinessUI(businessUI);

            dispatch(shareBusinessAsync(businessModel));
        },
        [dispatch],
    );

    const onSubscribe = useCallback(
        authenticationService.protect((businessUI: BusinessUI) => {
            const businessModel = fromBusinessUI(businessUI);

            dispatch(subscribeToBusinessAsync(businessModel, EventSource.BUSINESS, 0));
        }),
        [dispatch],
    );

    return {
        onShare,
        onSubscribe,
    };
};
